import axios from 'axios';

export const authAxios = axios.create({ baseURL: '', withCredentials: true });

export const apiErrorMessage = (e) => e.response?.data?.detail || e.message;
